import { useCallback, useState } from 'react';

import { useEncryption } from '../constants/config';
import EThreeService from '../utils/EThreeService';

interface HookReturn {
  loading: boolean;
  eThreeInit: () => Promise<void>;
}
const useEThreeInit = (initialLoading = false): HookReturn => {
  const [loading, setLoading] = useState<boolean>(initialLoading);

  const eThreeInit = useCallback(async () => {
    setLoading(true);
    if (useEncryption) {
      await EThreeService.initialize();
      await EThreeService.register();
    }
    setLoading(false);
  }, []);

  return {
    loading,
    eThreeInit,
  };
};

export default useEThreeInit;
